import { useState, useEffect, useRef } from "react";
import { useContext } from "react";
import MainContext from "../../context/mainContext";
import Typography from "@mui/material/Typography";
import * as React from "react";
import SaveAsWordsDialog from "./Translations/SaveAsWordsDialog";
import SubtitleOnePopover from "./Translations/SubtitleOnePopover";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import IconButton from "@mui/material/IconButton";
import GTranslateIcon from "@mui/icons-material/GTranslate";
import ModalAlert from "./Translations/ModalAlert";
import { Box } from "@mui/material";

function SubtitleOneContentControl(props) {
  const {
    paperComponent,
    handleFullScreen,
    handlePlayingStatus,
    handleUseShortcuts,
  } = props;
  const {
    subtitleOneWords,
    subtitleOneContenet,
    subtitleTwoContenet,
    userTypes,
    videoInfo,
  } = useContext(MainContext);
  const [translateWord, setTranslateWord] = useState("");
  const [dict, setDict] = useState(false);
  const [enDataDict, setEnDataDict] = useState(false);
  const [openSaveAsWordsDialog, setOpenSaveAsWordsDialog] = useState(false);
  const [typeWord, setTypeWord] = useState("word");

  const [openModalAlert, setOpenModalAlert] = React.useState(false);

  const handleOpenModalAlert = () => {
    setOpenModalAlert(!openModalAlert);
  };

  const handleTranslateWord = (w) => {
    setTranslateWord(w);
  };
  const handleDict = (m) => {
    setDict(m);
  };
  const handleEnData = (m) => {
    setEnDataDict(m);
  };

  const handleOpenSaveAsWordsDialog = (clearData) => {
    handlePlayingStatus(false, "openDict");
    if (clearData) {
      setTranslateWord("");
      setDict(false);
      setTypeWord("word");
    }
    setOpenSaveAsWordsDialog(!openSaveAsWordsDialog);
    handleUseShortcuts({ enable: openSaveAsWordsDialog });
  };

  const handleOpenSaveWordsDialog = (clearData) => {
    if (clearData) {
      setTranslateWord("");
      setDict(false);
      setTypeWord("word");
    }
    setOpenSaveAsWordsDialog(!openSaveAsWordsDialog);
    handleUseShortcuts({ enable: openSaveAsWordsDialog });
  };

  const htmlSubContent = () => {
    let { allWords, words } = subtitleOneWords;
    let htmlres = allWords.map((w, index) => {
      return w.length == 0 ? (
        <span key={`word-${index}`}> </span>
      ) : words.indexOf(w) < 0 ? (
        <span key={`word-${index}`}>{`${w}`}</span>
      ) : (
        <SubtitleOnePopover
          handlePlayingStatus={handlePlayingStatus}
          containerRef={paperComponent}
          handleFullScreen={handleFullScreen}
          subWord={w}
          key={`word-${index}`}
          handleTranslateWord={handleTranslateWord}
          handleDict={handleDict}
          handleEnData={handleEnData}
          handleOpenSaveWordsDialog={handleOpenSaveWordsDialog}
          handleOpenSaveAsWordsDialog={handleOpenSaveAsWordsDialog}
          typeWord={typeWord}
          handleOpenModalAlert={handleOpenModalAlert}
        />
      );
    });
    return htmlres;
  };
  const doAction = (action) => {
    if (
      userTypes.includes("userPremium") ||
      userTypes.includes("admin") ||
      userTypes.includes("freetrial_all")
    ) {
      if (action == "saveSentence") {
        setDict([
          {
            pos: "noPos",
            baseForm: translateWord,
            translations: [subtitleTwoContenet],
          },
        ]);
        setTranslateWord(subtitleOneContenet);
        handleOpenSaveWordsDialog();
        setTypeWord("sentence");
      } else if (action == "translate") {
        setDict([
          {
            pos: "noPos",
            baseForm: translateWord,
            translations: [subtitleTwoContenet],
          },
        ]);
        setTranslateWord(subtitleOneContenet);
        handleOpenSaveAsWordsDialog();
        setTypeWord("sentence");
        window.open(
          `https://www.bing.com/translator/?from=${videoInfo["subtitleOneLanguage"]}&to=${videoInfo["subtitleTwoLanguage"]}&text=${subtitleOneContenet}`,
          "mozillaWindow",
          "popup"
        );
      }
    } else {
      handleOpenModalAlert();
    }
  };
  return (
    <Box sx={{ direction: "rtl", fontSize: "inherit" }}>
      {openModalAlert ? (
        <ModalAlert
          handleOpenModalAlert={handleOpenModalAlert}
          openModalAlert={openModalAlert}
          handleFullScreen={handleFullScreen}
          handlePlayingStatus={handlePlayingStatus}
        />
      ) : null}
      {subtitleOneContenet.length !== 0 ? (
        <IconButton
          onClick={() => {
            doAction("translate");
          }}
          color="primary"
        >
          <GTranslateIcon />
        </IconButton>
      ) : null}
      {htmlSubContent()}
      {subtitleOneContenet.length !== 0 ? (
        <IconButton
          onClick={() => {
            doAction("saveSentence");
          }}
          color="primary"
        >
          <SaveAsIcon />
        </IconButton>
      ) : null}
      {/* <SaveWordsDialog
        paperComponent={paperComponent}
        openSaveAsWordsDialog={openSaveAsWordsDialog}
        handleOpenSaveWordsDialog={handleOpenSaveWordsDialog}
        meinings={meinings}
        dict={dict}
        translateWord={translateWord}
        typeWord={typeWord}
        handleFullScreen={handleFullScreen}
      /> */}
      <SaveAsWordsDialog
        paperComponent={paperComponent}
        openSaveAsWordsDialog={openSaveAsWordsDialog}
        handleOpenSaveAsWordsDialog={handleOpenSaveAsWordsDialog}
        dict={dict}
        enDataDict={enDataDict}
        translateWord={translateWord}
        typeWord={typeWord}
        handleFullScreen={handleFullScreen}
        handlePlayingStatus={handlePlayingStatus}
      />
    </Box>
  );
}

export default SubtitleOneContentControl;
